import { useRef } from 'react';
import s from './ProductsByCategory.module.scss';
import { ReactComponent as IconArrow } from 'images/arrow-down-w.svg';
import { useTranslation } from 'react-i18next';

interface BrandFilterProps {
  selectedBrand: string;
  setSelectedBrand: (brand: string) => void;
  showBrandsDropdown: boolean;
  setShowBrandsDropdown: (show: boolean) => void;
  brands?: Array<{ id: number; name: string }>;
}

const BrandFilter = ({
  selectedBrand,
  setSelectedBrand,
  showBrandsDropdown,
  setShowBrandsDropdown,
  brands
}: BrandFilterProps) => {
  const {t} = useTranslation() as any
  const dropdownRef = useRef<HTMLDivElement>(null);

  return (
    <div className={s.products_filter}>
      <div className={s.products_filter_title}>{t('Brands')}</div>
      <div
        className={s.products_filter_selection}
        onClick={() => setShowBrandsDropdown(!showBrandsDropdown)}
      >
        <div className={s.products_filter_selection_title}>
          {t(selectedBrand)}
        </div>
        <div className={s.products_filter_selection_icon}>
          <IconArrow />
        </div>
      </div>
      {showBrandsDropdown && (
        <div className={s.dropdown_menu} ref={dropdownRef}>
          <div
            className={s.dropdown_item}
            onClick={() => {
              setSelectedBrand('All');
              setShowBrandsDropdown(false);
            }}
          >
            {t('All')}
          </div>
          {brands?.map((brand) => (
            <div
              key={brand.id}
              className={s.dropdown_item}
              onClick={() => {
                setSelectedBrand(brand.name);
                setShowBrandsDropdown(false);
              }}
            >
              {t(brand.name)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BrandFilter;
